/* eslint-disable max-classes-per-file */
import { HearingSection } from '@ftr/annotations-contracts'
import { Uuid } from '@ftr/contracts/type/shared'
import { HearingSectionModel } from '@ftr/ui-rtstt'
import { LocalDate, LocalTime, ZoneId } from '@js-joda/core'
import { ManageCourtroomContext } from '../../types'

export class SetManageCourtroomInfo {
  static readonly type = '[Manage-Courtroom] Set Manage Courtroom Information'

  constructor(
    public recordingId: Uuid | undefined,
    public courtSystemId: Uuid | undefined,
    public recordingName: string | undefined,
    public manageCourtroomContext?: ManageCourtroomContext,
  ) {}
}

export class SetRecordingTimezone {
  static readonly type = '[Manage-Courtroom] Set Recording Timezone'

  constructor(public recordingTimezone: ZoneId) {}
}

export class ResetCourtRecording {
  static readonly type = '[Manage-Courtroom] Reset Recording'
}

export class ResetCourtroom {
  static readonly type = '[Manage-Courtroom] Reset Courtroom'
}

export class GetCourtroom {
  static readonly type = '[Manage-Courtroom] Get Courtroom'

  constructor(
    public locationId: Uuid,
    public courtSystemId: Uuid,
  ) {}
}

export class GetRecordingStatus {
  static readonly type = '[Manage-Courtroom] Get Recording Status'

  constructor(
    public locationId: Uuid,
    public courtSystemId: Uuid,
  ) {}
}

export class GetDepartments {
  static readonly type = '[Manage-Courtroom] Get Departments'

  constructor(public courtSystemId: Uuid) {}
}

export class SetDepartment {
  static readonly type = '[Manage-Courtroom] Set Department'

  constructor(public departmentId: Uuid | null | undefined) {}
}

export class FetchActiveHearingSection {
  static readonly type = '[Manage-Courtroom] Fetch Active Hearing Section'

  constructor(
    public courtSystemId: Uuid,
    public courtroomId: Uuid,
  ) {}
}

export class SetActiveHearingSection {
  static readonly type = '[Manage-Courtroom] Set Active Hearing Section'

  constructor(public activeHearingSection: HearingSectionModel | undefined) {}
}

export class StartCourtroomHearingAction {
  static readonly type = '[Manage-Courtroom] Start Courtroom Hearing'
  constructor(
    readonly courtSystemId: Uuid,
    readonly startTime: LocalTime,
    readonly recordingDate: LocalDate,
    readonly locationId: Uuid,
    readonly courtroomSessionId: Uuid | undefined,
  ) {}
}

export class StopCourtroomHearingAction {
  static readonly type = '[Manage-Courtroom] Stop Courtroom Hearing'
  constructor(
    readonly courtSystemId: Uuid,
    readonly startTime: LocalTime,
    readonly recordingDate: LocalDate,
    readonly locationId: Uuid,
    readonly courtroomSessionId: Uuid | undefined,
  ) {}
}

export class UpdateCourtroomHearingAction {
  static readonly type = '[Manage-Courtroom] Update Courtroom Hearing'
  constructor(
    readonly courtSystemId: Uuid,
    readonly startTime: LocalTime,
    readonly recordingDate: LocalDate,
    readonly locationId: Uuid,
    readonly courtroomSessionId: Uuid | undefined,
    readonly hearingSection: Partial<HearingSection>,
  ) {}
}
